var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceStatusType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.268,
    height: 20,
    viewBox: "0 0 16.268 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-681.2-514.966c-.274-.36-.558-.734-.826-1.162a9.554,9.554,0,0,1-.627-1.192c-.25-.6-.62-1.8-.621-1.8l-.219-.779-.525,1.339a14.76,14.76,0,0,1-1.44,2.672c-.118.17-.244.344-.374.523-.9,1.247-2.024,2.8-1.823,4.547a4.909,4.909,0,0,0,1.133,2.684,3.666,3.666,0,0,0,2.825,1.239,4.123,4.123,0,0,0,3.987-4.412A5.518,5.518,0,0,0-681.2-514.966Zm-2.5,6.981a2.575,2.575,0,0,1-2.012-.873,3.813,3.813,0,0,1-.865-2.085c-.152-1.326.79-2.63,1.622-3.781l.018-.025c.127-.176.251-.348.368-.515a14.342,14.342,0,0,0,.94-1.568,10.7,10.7,0,0,0,.68,1.284c.292.468.591.86.879,1.239a4.467,4.467,0,0,1,1.27,3A3.029,3.029,0,0,1-683.692-507.985Z",
    transform: "translate(695.974 526.896)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-702.982-562.328c-.208-.274-.424-.558-.628-.884a7.3,7.3,0,0,1-.477-.906c-.19-.456-.472-1.366-.472-1.369l-.166-.592-.4,1.018a11.225,11.225,0,0,1-1.095,2.032c-.09.129-.186.262-.284.4-.685.949-1.539,2.129-1.386,3.457a3.732,3.732,0,0,0,.861,2.041,2.787,2.787,0,0,0,2.148.942,3.135,3.135,0,0,0,3.031-3.355A4.2,4.2,0,0,0-702.982-562.328Zm-1.9,5.134a1.791,1.791,0,0,1-1.4-.605,2.727,2.727,0,0,1-.616-1.49,4.428,4.428,0,0,1,1.2-2.753l.027-.038c.093-.128.183-.253.268-.375a10.533,10.533,0,0,0,.563-.907,7.809,7.809,0,0,0,.38.684c.226.362.466.677.677.955a3.262,3.262,0,0,1,.93,2.176A2.136,2.136,0,0,1-704.881-557.194Z",
    transform: "translate(713.143 566.079)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-737.049-523.69c-.229-.3-.466-.612-.689-.97a8.055,8.055,0,0,1-.524-.995c-.209-.5-.518-1.5-.518-1.5l-.183-.65-.438,1.117a12.314,12.314,0,0,1-1.2,2.231c-.1.142-.2.287-.312.436-.753,1.041-1.69,2.337-1.522,3.8a4.1,4.1,0,0,0,.945,2.241,3.06,3.06,0,0,0,2.358,1.034,3.441,3.441,0,0,0,3.327-3.683A4.6,4.6,0,0,0-737.049-523.69Zm-2.084,5.647a1.978,1.978,0,0,1-1.546-.668,3,3,0,0,1-.678-1.642c-.119-1.037.646-2.1,1.321-3.03l.043-.059c.1-.134.191-.265.281-.393a11.672,11.672,0,0,0,.627-1.012,8.356,8.356,0,0,0,.426.768c.247.4.509.74.739,1.044a3.6,3.6,0,0,1,1.026,2.4A2.356,2.356,0,0,1-739.133-518.043Z",
    transform: "translate(742.457 533.607)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceStatusType);
export default __webpack_public_path__ + "static/media/resourceStatusType.61f3c39b.svg";
export { ForwardRef as ReactComponent };